import {
  VENDOR_CONTRACT_FETCHING,
  VENDOR_CONTRACT_FAILED,
  VENDOR_CONTRACT_SUCCESS,
} from "../actions/types";

const initialState = {
  result: [],
  isFetching: true,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case VENDOR_CONTRACT_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case VENDOR_CONTRACT_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };
    case VENDOR_CONTRACT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
